import { useModal } from 'modals';
import GreenLink from 'components/GreenLink';
import SectionHeader from 'components/SectionHeader';

export default function ConnectSection() {
  const { open } = useModal();
  return (
    <section className="py-(--vertical-spacing)">
      <div className="container">
        <SectionHeader
          title="Get in touch"
          description="Cartwheel is built for—and with—production teams. Contact us to request a feature, join early access, or share feedback."
        />

        <div className="mt-4 flex flex-col gap-4 lg:mt-8 lg:gap-6">
          <GreenLink onClick={() => open('ENTERPRISE_CONTACT', { reason: 'request_api_access' })}>Contact us</GreenLink>
          <GreenLink href="https://www.linkedin.com/company/getcartwheel/">LinkedIn</GreenLink>
          <GreenLink href="https://www.youtube.com/@getcartwheel">YouTube</GreenLink>
        </div>
      </div>
    </section>
  );
}
